import { z } from 'zod';
import {
  CountryCodeValues,
  CountryCodeAddressCountryValues,
} from '@axiom/const';
import { ZodArrayToEnum } from '@axiom/types';

export const MfaPhoneNumberSchema = z.object({
  phoneNumberCountry: z
    .enum(ZodArrayToEnum(CountryCodeAddressCountryValues))
    .nullable(),
  phoneNumberCountryCode: z.enum(ZodArrayToEnum(CountryCodeValues)).nullable(),
  phoneNumber: z.string().regex(/^\d+$/).nullable(),
  registeredForMfa: z.boolean().nullable(),
});

export type MfaPhoneNumber = z.infer<typeof MfaPhoneNumberSchema>;

export const MfaVerificationSchema = z.object({
  mfaCode: z
    .string()
    .trim()
    .regex(/^\d{6}$/, 'Invalid Code Format'),
});

export type MfaVerification = z.infer<typeof MfaVerificationSchema>;

export const MfaPhoneNumberPreferencesSchema = z.object({
  notificationsPhoneNumber: z.string().regex(/^\d+$/).nullable(),
  notificationsPhoneNumberCountry: z
    .enum(ZodArrayToEnum(CountryCodeAddressCountryValues))
    .nullable(),
  notificationsPhoneNumberCountryCode: z
    .enum(ZodArrayToEnum(CountryCodeValues))
    .nullable(),
  registeredForMfa: z.boolean(),
});

export type MfaPhoneNumberPreferences = z.infer<
  typeof MfaPhoneNumberPreferencesSchema
>;
